import { render, staticRenderFns } from "./comboComp.vue?vue&type=template&id=2aa7673d&"
import script from "./comboComp.vue?vue&type=script&lang=js&"
export * from "./comboComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports